import { style } from 'typestyle'

/* Styles ======================================================================================= */
import { StyleClass } from '../style-class'

/* Types ======================================================================================== */
type ClassNames = {
  /**
   * Base class for tabs
   */
  base: string

  /**
   * Proped class for tabs
   */
  proped: {
    active: string
  }

  /**
   * Base class for tabs header
   */
  header: string
}

type ClassProps = object

const getNames: (props: ClassProps, theme: any) => ClassNames = (props, theme) => {
  const base = style({
    width: '100%',
    height: '100%',
    position: 'relative',
  })

  const proped = {
    active: style({ display: 'initial' }),
  }

  const header = style({
    overflow: 'hidden',
    // height: 49,
    borderBottom: `1px solid ${theme.boxes.border.medium}`,
    zIndex: 2,
  })

  return {
    base,
    proped,
    header,
  }
}

/* Export ======================================================================================= */
export const tabsClass = new StyleClass<ClassNames, ClassProps>(getNames)
